window.Products.Clothing.YouthLeggings = function() {
};

window.Products.Clothing.YouthLeggings.inherits(window.Products.Clothing.Clothing);
window.Products.Clothing.YouthLeggings.id = 60;
window.Products.Clothing.YouthLeggings.slug = 'youth-leggings';
window.Products.Clothing.YouthLeggings.has_3d = true;
window.Products.Clothing.YouthLeggings.has_subproducts = true;
window.Products.Clothing.YouthLeggings.dpi = 150;
window.Products.Clothing.YouthLeggings.camera_fixed = 1.4;

window.Products.Clothing.YouthLeggings.prototype.set3dProperties = function(modelViewer) {
    modelViewer.object.children[0].position.y = 0.035;
    modelViewer.object.children[1].position.y = 0.035;

    yRotation = new THREE.Matrix4();
    yRotation.makeRotationAxis(new THREE.Vector3(0, 1, 0).normalize(), 180 * Math.PI / 180);
    modelViewer.object.matrix = yRotation;
    modelViewer.object.rotation.setFromRotationMatrix(modelViewer.object.matrix);
    
    this.updateThreeTexture(modelViewer);
    modelViewer.initalCameraPosition.z = this.parent.static.camera_fixed;
    if(!modelViewer.inlab){
        modelViewer.setFixedView('front');
        modelViewer.enableAutoRotate(0.5);
        modelViewer.camera.position.z = 0.5;
    }
};

window.Products.Clothing.YouthLeggings.prototype.setThreeControls = function(controls) {
    controls.minDistance = 1.4;
    controls.maxDistance = 1.8;
};

window.Products.Clothing.YouthLeggings.prototype.updateThreeTexture = function(modelViewer) {
    modelViewer.object.children[0].material.map = modelViewer.texture;
    modelViewer.object.children[1].material.map = modelViewer.texture;
    modelViewer.object.children[0].material.bumpScale = 0.0005;
    modelViewer.object.children[1].material.bumpScale = 0.0005;
};